import {
  AlignCenterOutlined,
  AlignLeftOutlined,
  AlignRightOutlined,
  BoldOutlined,
  ItalicOutlined,
  OrderedListOutlined,
  StrikethroughOutlined,
  UnderlineOutlined,
  UnorderedListOutlined
} from '@ant-design/icons'
import { IconFont } from '../Iconfont'
import BlockButton from './block-button'
import ImageBtn from './ImageBtn'
import MarkButton from './mark-button'

const SlateToolbar = () => {
  return (
    <div className='editor-toolbar'>
      <div className='icon-btn-group'>
        <MarkButton format='bold' icon={<BoldOutlined />} />
        <MarkButton format='italic' icon={<ItalicOutlined />} />
        <MarkButton format='strikethrough' icon={<StrikethroughOutlined />} />
        <MarkButton format='underline' icon={<UnderlineOutlined />} />
      </div>

      <div className='icon-btn-group'>
        <BlockButton format='heading-one' icon={<IconFont type='icon-h1' />} />
        <BlockButton format='heading-two' icon={<IconFont type='icon-h2' />} />
      </div>
      <MarkButton format='code' icon={<IconFont type='icon-code' />} />

      <BlockButton format='block-quote' icon={<IconFont type='icon-quote' />} />
      <BlockButton format='numbered-list' icon={<OrderedListOutlined />} />
      <BlockButton format='bulleted-list' icon={<UnorderedListOutlined />} />
      <BlockButton format='left' icon={<AlignLeftOutlined />} />
      <BlockButton format='center' icon={<AlignCenterOutlined />} />
      <BlockButton format='right' icon={<AlignRightOutlined />} />
      <ImageBtn />
      {/* <PopupActionButton format="table" icon="icon-table"></PopupActionButton> */}
    </div>
  )
}

export default SlateToolbar
